import React from "react";
import { Typography, Grid, Paper } from "@material-ui/core";
import { useStyles } from "./style";
import moment from "moment";
import { Tooltip } from "@mui/material";

interface Props {
  details: any;
  nomination: any;
  vehicleStatus?: any;
  isExportMode?: boolean;
}

export function TerminalDetails({
  details,
  nomination,
  vehicleStatus = {},
  isExportMode = false,
}: Props): React.ReactElement {
  const classes = useStyles();
  const terminalType = Number(localStorage.getItem("terminalType"));
  const destuffDateStr = details?.destuffingDate;
  const gateinDate = details?.gateInDate || details?.createdDateTime;
  let storageDays = 0;
  if (details?.containerType === "CY") {
    if (gateinDate) {
      const createdDate = new Date(gateinDate);
      const today = new Date();

      // Remove the +5 grace days
      const diffTime = today.getTime() - createdDate.getTime();

      storageDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    }
  } else {
    if (destuffDateStr) {
      const createdDate = new Date(destuffDateStr);
      const today = new Date();

      // Remove the +5 grace days
      const diffTime = today.getTime() - createdDate.getTime();

      storageDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    }
  }

  function truncateString(str: string, maxLength = 8) {
    if (str.length > maxLength) {
      return `${str.slice(0, maxLength)}...`;
    }
    return str;
  }

  // Toggle headings based on mode so the relevant section is always visible.
  // Export: always show the vehicle status headings (values fill once a vehicle is selected).
  // Import/others: always show container details headings; vehicle status shows only when fetched.
  const hasVehicleStatus = vehicleStatus && Object.keys(vehicleStatus).length > 0;
  const showVehicleStatus = isExportMode || hasVehicleStatus;
  const showContainerDetails = !isExportMode;

  return (
    <div>
      <Paper
        elevation={1}
        variant="outlined"
        style={{ padding: "20px", backgroundColor: "rgb(0 0 0 / 7%)", border: "none" }}
      >
        <Grid spacing={2} container direction="row" justifyContent="space-between">
          {showVehicleStatus ? (
            <>
              {/* Vehicle Status Fields - shown when NOT in export mode */}
              {/* <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                <Grid item xs={6} md={6} lg={6}>
                  <Typography className={classes.readOnyTitle}>Vehicle Status ID:</Typography>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Typography>{vehicleStatus?.vehicleStatusId || "-"}</Typography>
                </Grid>
              </Grid> */}
              <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                <Grid item xs={6} md={6} lg={6}>
                  <Typography className={classes.readOnyTitle}>Terminal Location:</Typography>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Tooltip title={vehicleStatus?.terminalLocationName || "-"} followCursor>
                    <span>{truncateString(vehicleStatus?.terminalLocationName || "") || "-"}</span>
                  </Tooltip>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                <Grid item xs={6} md={6} lg={6}>
                  <Typography className={classes.readOnyTitle}>Cargo Type:</Typography>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Tooltip title={vehicleStatus?.cargoTypeName || "-"} followCursor>
                    <span>{truncateString(vehicleStatus?.cargoTypeName || "") || "-"}</span>
                  </Tooltip>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                <Grid item xs={6} md={6} lg={6}>
                  <Typography className={classes.readOnyTitle}>Consignment Type:</Typography>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Tooltip title={vehicleStatus?.consignmentTypeName || "-"} followCursor>
                    <span>{truncateString(vehicleStatus?.consignmentTypeName || "") || "-"}</span>
                  </Tooltip>
                </Grid>
              </Grid>
              {/* <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                <Grid item xs={6} md={6} lg={6}>
                  <Typography className={classes.readOnyTitle}>Container Number:</Typography>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Tooltip title={vehicleStatus?.containerNumber || "-"} followCursor>
                    <span>{truncateString(vehicleStatus?.containerNumber || "") || "-"}</span>
                  </Tooltip>
                </Grid>
              </Grid> */}
              <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                <Grid item xs={6} md={6} lg={6}>
                  <Typography className={classes.readOnyTitle}>Date/Time:</Typography>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Typography>
                    {vehicleStatus?.dateTime ? (
                      <Tooltip
                        title={
                          `${moment(vehicleStatus.dateTime).format("DD-MM-YYYY hh:mm a")}` || "-"
                        }
                        followCursor
                      >
                        <span>
                          {truncateString(
                            `${moment(vehicleStatus.dateTime).format("DD-MM-YYYY hh:mm a")}` || ""
                          ) || "-"}
                        </span>
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                <Grid item xs={6} md={6} lg={6}>
                  <Typography className={classes.readOnyTitle}>Cargo Type:</Typography>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Tooltip title={vehicleStatus?.cargoType || "-"} followCursor>
                    <span>{truncateString(vehicleStatus?.cargoType || "") || "-"}</span>
                  </Tooltip>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                <Grid item xs={6} md={6} lg={6}>
                  <Typography className={classes.readOnyTitle}>Container Size:</Typography>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Tooltip title={vehicleStatus?.containerSize || "-"} followCursor>
                    <span>{truncateString(vehicleStatus?.containerSize || "") || "-"}</span>
                  </Tooltip>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                <Grid item xs={6} md={6} lg={6}>
                  <Typography className={classes.readOnyTitle}>Container Type:</Typography>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Tooltip title={vehicleStatus?.containerType || "-"} followCursor>
                    <span>{truncateString(vehicleStatus?.containerType || "") || "-"}</span>
                  </Tooltip>
                </Grid>
              </Grid>
              {/* <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                <Grid item xs={6} md={6} lg={6}>
                  <Typography className={classes.readOnyTitle}>Vehicle ID:</Typography>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Typography>{vehicleStatus?.vehicleId || "-"}</Typography>
                </Grid>
              </Grid> */}
              <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                <Grid item xs={6} md={6} lg={6}>
                  <Typography className={classes.readOnyTitle}>Vehicle Type:</Typography>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Tooltip title={vehicleStatus?.vehicleType || "-"} followCursor>
                    <span>{truncateString(vehicleStatus?.vehicleType || "") || "-"}</span>
                  </Tooltip>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                <Grid item xs={6} md={6} lg={6}>
                  <Typography className={classes.readOnyTitle}>Vehicle Weight:</Typography>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Typography>
                    {vehicleStatus?.vehicleWeight
                      ? `${vehicleStatus.vehicleWeight} ${
                          vehicleStatus?.vehicleWeightUnit || ""
                        }`.trim()
                      : "-"}
                  </Typography>
                </Grid>
              </Grid>
            </>
          ) : null}
          {showContainerDetails && (
            <>
              {/* Original Container Details Fields - hidden when in export mode */}
              {terminalType !== 4 && (
                <>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    container
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item xs={6} md={6} lg={6}>
                      <Typography className={classes.readOnyTitle}>BL #:</Typography>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6}>
                      <Tooltip title={details?.blNumber || "-"} followCursor>
                        <span>{truncateString(details?.blNumber || "") || "-"}</span>
                      </Tooltip>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    container
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item xs={6} md={6} lg={6}>
                      <Typography className={classes.readOnyTitle}>Vessel:</Typography>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6}>
                      <Tooltip title={details?.vessel || "-"} followCursor>
                        <span>{truncateString(details?.vessel || "") || "-"}</span>
                      </Tooltip>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    container
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item xs={6} md={6} lg={6}>
                      <Typography className={classes.readOnyTitle}>Voyage:</Typography>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6}>
                      <Typography>
                        <Tooltip title={details?.voyage || "-"} followCursor>
                          <span>{truncateString(details?.voyage || "") || "-"}</span>
                        </Tooltip>
                      </Typography>
                    </Grid>
                  </Grid>
                </>
              )}
              <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                <Grid item xs={6} md={6} lg={6}>
                  <Typography className={classes.readOnyTitle}>Forwarder:</Typography>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Typography>
                    <Tooltip title={details?.forwarder || "-"} followCursor>
                      <span>{truncateString(details?.forwarder || "") || "-"}</span>
                    </Tooltip>
                  </Typography>
                </Grid>
              </Grid>
              {/* <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
            <Grid item xs={6} md={6} lg={6}>
              <Typography className={classes.readOnyTitle}>Client:</Typography>
            </Grid>
            <Grid item xs={6} md={6} lg={6}>
              <Typography>
                <Tooltip title={details?.client || "-"} followCursor>
                  <span>{truncateString(details?.client || "") || "-"}</span>
                </Tooltip>
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
            <Grid item xs={6} md={6} lg={6}>
              <Typography className={classes.readOnyTitle}>Line:</Typography>
            </Grid>
            <Grid item xs={6} md={6} lg={6}>
              <Typography>
                <Tooltip title={details?.line || "-"} followCursor>
                  <span>{truncateString(details?.line || "") || "-"}</span>
                </Tooltip>
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
            <Grid item xs={6} md={6} lg={6}>
              <Typography className={classes.readOnyTitle}>Consignee:</Typography>
            </Grid>
            <Grid item xs={6} md={6} lg={6}>
              <Typography>
                <Tooltip title={details?.consignee || "-"} followCursor>
                  <span>{truncateString(details?.consignee || "") || "-"}</span>
                </Tooltip>
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
            <Grid item xs={6} md={6} lg={6}>
              <Typography className={classes.readOnyTitle}>C&F Agent:</Typography>
            </Grid>
            <Grid item xs={6} md={6} lg={6}>
              <Typography>
                <Tooltip title={details?.cnfAgent || "-"} followCursor>
                  <span>{truncateString(details?.cnfAgent || "") || "-"}</span>
                </Tooltip>
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
            <Grid item xs={6} md={6} lg={6}>
              <Typography className={classes.readOnyTitle}>Agent:</Typography>
            </Grid>
            <Grid item xs={6} md={6} lg={6}>
              <Typography>
                <Tooltip title={details?.clearingAgent || "-"} followCursor>
                  <span>{truncateString(details?.clearingAgent || "") || "-"}</span>
                </Tooltip>
              </Typography>
            </Grid>
          </Grid> */}
              <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                <Grid item xs={6} md={6} lg={6}>
                  <Typography className={classes.readOnyTitle}>STax:</Typography>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Typography>
                    <Typography>
                      <Tooltip title={details?.sTaxAuthority || "-"} followCursor>
                        <span>{truncateString(details?.sTaxAuthority || "") || "-"}</span>
                      </Tooltip>
                    </Typography>
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                <Grid item xs={6} md={6} lg={6}>
                  <Typography className={classes.readOnyTitle}>Storage Start:</Typography>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Typography>
                    {details?.storageStartDate ? (
                      <Tooltip
                        title={
                          `${moment(details?.storageStartDate).format("DD-MM-YYYY hh:mm a")}` || "-"
                        }
                        followCursor
                      >
                        <span>
                          {truncateString(
                            `${moment(details?.storageStartDate).format("DD-MM-YYYY hh:mm a")}` ||
                              ""
                          ) || "-"}
                        </span>
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                <Grid item xs={6} md={6} lg={6}>
                  <Typography className={classes.readOnyTitle}>Storage End:</Typography>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Typography>
                    {details?.storageEndDate ? (
                      <Tooltip
                        title={
                          `${moment(details?.storageEndDate).format("DD-MM-YYYY hh:mm a")}` || "-"
                        }
                        followCursor
                      >
                        <span>
                          {truncateString(
                            `${moment(details?.storageEndDate).format("DD-MM-YYYY hh:mm a")}` || ""
                          ) || "-"}
                        </span>
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </Typography>
                </Grid>
              </Grid>
              {terminalType !== 4 && (
                <>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    container
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item xs={6} md={6} lg={6}>
                      <Typography className={classes.readOnyTitle}>Weight/CBM:</Typography>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6}>
                      <Typography>
                        <Tooltip title={details?.weightCBM || "-"} followCursor>
                          <span>{truncateString(details?.weightCBM || "") || "-"}</span>
                        </Tooltip>
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    container
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item xs={6} md={6} lg={6}>
                      <Typography className={classes.readOnyTitle}>Billing CBM:</Typography>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6}>
                      <Typography>
                        <Tooltip title={details?.billingCBM || "-"} followCursor>
                          <span>{details?.billingCBM || "-"}</span>
                        </Tooltip>
                      </Typography>
                    </Grid>
                  </Grid>
                </>
              )}
              <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                <Grid item xs={6} md={6} lg={6}>
                  <Typography className={classes.readOnyTitle}>Gate In Date:</Typography>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Typography>
                    {details?.gateInDate || details?.createdDateTime ? (
                      <Tooltip
                        title={
                          `${moment(details?.gateInDate || details?.createdDateTime).format(
                            "DD-MM-YYYY hh:mm a"
                          )}` || "-"
                        }
                        followCursor
                      >
                        <span>
                          {truncateString(
                            `${moment(details?.gateInDate || details?.createdDateTime).format(
                              "DD-MM-YYYY hh:mm a"
                            )}` || ""
                          ) || "-"}
                        </span>
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                <Grid item xs={6} md={6} lg={6}>
                  <Typography className={classes.readOnyTitle}>Destuffing:</Typography>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Typography>
                    {details?.destuffingDate ? (
                      <Tooltip
                        title={
                          `${moment(details?.destuffingDate).format("DD-MM-YYYY hh:mm a")}` || "-"
                        }
                        followCursor
                      >
                        <span>
                          {truncateString(
                            `${moment(details?.destuffingDate).format("DD-MM-YYYY hh:mm a")}` || ""
                          ) || "-"}
                        </span>
                      </Tooltip>
                    ) : (
                      "-"
                    )}
                  </Typography>
                </Grid>
              </Grid>
              {terminalType !== 4 && (
                <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                  <Grid item xs={6} md={6} lg={6}>
                    <Typography className={classes.readOnyTitle}>Index Storage (Days):</Typography>
                  </Grid>
                  <Grid item xs={6} md={6} lg={6}>
                    <Typography>
                      <Tooltip title={storageDays || 0} followCursor>
                        <span>{storageDays || 0}</span>
                      </Tooltip>
                    </Typography>
                  </Grid>
                </Grid>
              )}
              {terminalType !== 4 && (
                <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                  <Grid item xs={6} md={6} lg={6}>
                    <Typography className={classes.readOnyTitle}>Per CBM Amount:</Typography>
                  </Grid>
                  <Grid item xs={6} md={6} lg={6}>
                    <Typography>
                      <Tooltip title={nomination?.perCbm || "-"} followCursor>
                        <span>{truncateString(nomination?.perCbm || "") || "-"}</span>
                      </Tooltip>
                    </Typography>
                  </Grid>
                </Grid>
              )}
              {terminalType !== 4 && (
                <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                  <Grid item xs={6} md={6} lg={6}>
                    <Typography className={classes.readOnyTitle}>Per Index Amount:</Typography>
                  </Grid>
                  <Grid item xs={6} md={6} lg={6}>
                    <Typography>
                      <Tooltip title={nomination?.perIndex || "-"} followCursor>
                        <span>{truncateString(nomination?.perIndex || "") || "-"}</span>
                      </Tooltip>
                    </Typography>
                  </Grid>
                </Grid>
              )}
              {terminalType !== 4 && (
                <>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    container
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item xs={6} md={6} lg={6}>
                      <Typography className={classes.readOnyTitle}>Demurrage Applied:</Typography>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6}>
                      <Typography>
                        <Tooltip
                          title={details?.demurrageApplied === 1 ? "True" : "False"}
                          followCursor
                        >
                          <span>{details?.demurrageApplied === 1 ? "True" : "False"}</span>
                        </Tooltip>
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    container
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item xs={6} md={6} lg={6}>
                      <Typography className={classes.readOnyTitle}>Demurrage (Days):</Typography>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6}>
                      <Typography>
                        <Tooltip title={details?.noOfDemurrageDays || 0} followCursor>
                          <span>{details?.noOfDemurrageDays || 0}</span>
                        </Tooltip>
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    container
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item xs={6} md={6} lg={6}>
                      <Typography className={classes.readOnyTitle}>Fuel Charges:</Typography>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6}>
                      <Typography>
                        <Tooltip title={nomination?.fuelCharges || "-"} followCursor>
                          <span>{truncateString(nomination?.fuelCharges || "") || "-"}</span>
                        </Tooltip>
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    container
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item xs={6} md={6} lg={6}>
                      <Typography className={classes.readOnyTitle}>Inhand Indexes:</Typography>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6}>
                      <Typography>
                        <Tooltip title={details?.unpaidIndexCount || "-"} followCursor>
                          <span>{truncateString(details?.unpaidIndexCount || "") || "-"}</span>
                        </Tooltip>
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    container
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item xs={6} md={6} lg={6}>
                      <Typography className={classes.readOnyTitle}>Total Indexes:</Typography>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6}>
                      <Typography>
                        <Tooltip title={details?.totalIndexes || "-"} followCursor>
                          <span>{truncateString(details?.totalIndexes || "") || "-"}</span>
                        </Tooltip>
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    container
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item xs={6} md={6} lg={6}>
                      <Typography className={classes.readOnyTitle}>Tracking Charges:</Typography>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6}>
                      <Typography>
                        <Tooltip
                          title={
                            nomination?.trackingCharges && details?.totalIndexes
                              ? Math.round(nomination.trackingCharges / details.totalIndexes)
                              : "-"
                          }
                          followCursor
                        >
                          <span>
                            {truncateString(
                              nomination?.trackingCharges && details?.totalIndexes
                                ? String(
                                    Math.round(nomination.trackingCharges / details.totalIndexes)
                                  )
                                : ""
                            ) || "-"}
                          </span>
                        </Tooltip>
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    container
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item xs={6} md={6} lg={6}>
                      <Typography className={classes.readOnyTitle}>
                        Documentation Charges:
                      </Typography>
                    </Grid>
                    <Grid item xs={6} md={6} lg={6}>
                      <Typography>
                        <Tooltip title={nomination?.documentationCharges || "-"} followCursor>
                          <span>
                            {truncateString(nomination?.documentationCharges || "") || "-"}
                          </span>
                        </Tooltip>
                      </Typography>
                    </Grid>
                  </Grid>
                </>
              )}
              <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                <Grid item xs={6} md={6} lg={6}>
                  <Typography className={classes.readOnyTitle}>Container Size:</Typography>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Typography>
                    <Tooltip title={details?.containerSize || "-"} followCursor>
                      <span>{truncateString(details?.containerSize || "") || "-"}</span>
                    </Tooltip>
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                <Grid item xs={6} md={6} lg={6}>
                  <Typography className={classes.readOnyTitle}>Container Type:</Typography>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Typography>
                    <Tooltip title={details?.containerType || "-"} followCursor>
                      <span>{truncateString(details?.containerType || "") || "-"}</span>
                    </Tooltip>
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                <Grid item xs={6} md={6} lg={6}>
                  <Typography className={classes.readOnyTitle}>Cargo Weight:</Typography>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Typography>
                    <Tooltip title={details?.cargoWeight || "-"} followCursor>
                      <span>{truncateString(details?.cargoWeight || "") || "-"}</span>
                    </Tooltip>
                  </Typography>
                </Grid>
              </Grid>
              {terminalType !== 4 && (
                <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                  <Grid item xs={6} md={6} lg={6}>
                    <Typography className={classes.readOnyTitle}>
                      Terminal Handling Charges:
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={6} lg={6}>
                    <Typography>
                      <Tooltip title={nomination?.terminalHandlingCharges || "-"} followCursor>
                        <span>
                          {truncateString(nomination?.terminalHandlingCharges || "") || "-"}
                        </span>
                      </Tooltip>
                    </Typography>
                  </Grid>
                </Grid>
              )}
              <Grid item xs={12} md={4} container direction="row" justifyContent="space-between">
                <Grid item xs={6} md={6} lg={6}>
                  <Typography className={classes.readOnyTitle}>Cargo Types:</Typography>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <Typography>
                    <Tooltip title={details?.cargoType || "-"} followCursor>
                      <span>{truncateString(details?.cargoType || "") || "-"}</span>
                    </Tooltip>
                  </Typography>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </Paper>
    </div>
  );
}
